export function trimParams(params = {}) {
    let obj = {}
    for (let o in params) {
        if ( Object.prototype.hasOwnProperty.call(params, o) && params[o] !== '') {
            obj[o] = params[o]
        }
    }
    return obj
}